<template>
  <div class="app-header">
    <div class="header-left">
      <img src="@/assets/xiaogouqianqian.jpeg" class="logo" alt="logo" />
      <div class="brand">
        <span class="brand-title">股票统计</span>
        <span class="brand-sub">行稳致远见未来</span>
      </div>
    </div>

    <div class="header-center">
      <div class="marquee-container">
        <el-icon class="marquee-icon"><Bell /></el-icon>
        <div class="marquee">
          <span class="marquee-text">{{ message }}</span>
        </div>
      </div>
    </div>

    <!-- 用户区 -->
    <div class="header-right">
      <el-dropdown trigger="click" @command="handleCommand">
        <div class="user-trigger">
          <el-avatar :size="32" :src="avatar" class="user-avatar">
            {{ userName.slice(0, 1) }}
          </el-avatar>
          <div class="user-meta">
            <span class="user-name">{{ userName }}</span>
            <span class="user-role">{{ roleText }}</span>
          </div>
          <el-icon class="arrow"><ArrowDown /></el-icon>
        </div>

        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item command="profile">
              <el-icon><User /></el-icon> 个人信息
            </el-dropdown-item>
            <el-dropdown-item command="logout" divided>
              <el-icon><SwitchButton /></el-icon> 退出登录
            </el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import { Bell, ArrowDown, User, SwitchButton } from '@element-plus/icons-vue'
import { ElMessageBox, ElMessage } from 'element-plus'

export default {
  name: 'AppHeader',
  components: { Bell, ArrowDown, User, SwitchButton },
  data() {
    return {
      message:
        '所谓英雄，就是能够超越自己的父母、环境、学历、出身、性格特质等，突破所有限制，不按写就的剧本表演，让AI大数据对自己的行为无法预测，永远给大家以惊喜的人！'
    }
  },
  computed: {
    userName() {
      return this.$store.getters['user/userName']
    },
    avatar() {
      return this.$store.getters['user/avatar']
    },
    roleText() {
      const roles = this.$store.state.user.roles
      if (!roles.length) return '普通用户'
      return roles.join(' / ')
    }
  },
  methods: {
    async handleCommand(command) {
      if (command === 'logout') {
        await this.handleLogout()
      } else if (command === 'profile') {
        this.$router.push('/profile')
      }
    },

    async handleLogout() {
      try {
        await ElMessageBox.confirm('确定要退出登录吗？', '提示', {
          type: 'warning',
          confirmButtonText: '退出',
          cancelButtonText: '取消'
        })
      } catch (e) {
        return
      }

      await this.$store.dispatch('user/logout')
      ElMessage.success('已退出登录')
      this.$router.replace('/login')
    }
  }
}
</script>

<style lang="less" scoped>
.app-header {
  display: flex;
  align-items: center;
  height: 64px;
  padding: 0 24px;
  background: linear-gradient(135deg, #1e3c72 0%, #2a5298 100%);
  color: #fff;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.15);
}

.header-left {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;

  .logo {
    width: 44px;
    height: 44px;
    border-radius: 50%;
    border: 2px solid rgba(255, 255, 255, 0.5);
    object-fit: cover;
    transition: transform 0.3s ease;

    &:hover {
      transform: scale(1.08) rotate(5deg);
    }
  }

  .brand {
    display: flex;
    flex-direction: column;
    line-height: 1.2;

    .brand-title {
      font-size: 18px;
      font-weight: 700;
      letter-spacing: 1px;
    }

    .brand-sub {
      font-size: 12px;
      color: rgba(255, 255, 255, 0.7);
    }
  }
}

.header-center {
  flex: 1;
  margin-left: 32px;
  overflow: hidden;

  .marquee-container {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 8px 16px;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 20px;
    overflow: hidden;

    .marquee-icon {
      flex-shrink: 0;
      color: #ffd04b;
      font-size: 16px;
    }

    .marquee {
      flex: 1;
      overflow: hidden;
      white-space: nowrap;

      .marquee-text {
        display: inline-block;
        font-size: 13px;
        color: rgba(255, 255, 255, 0.9);
        animation: scroll-text 40s linear infinite;
      }
    }
  }
}

// ===== 用户区 =====
.header-right {
  flex-shrink: 0;
  margin-left: 16px;
}

.user-trigger {
  display: flex;
  align-items: center;
  gap: 9px;
  padding: 5px 10px 5px 5px;
  border-radius: 22px;
  cursor: pointer;
  transition: background 0.2s ease;
  outline: none;

  &:hover {
    background: rgba(255, 255, 255, 0.14);
  }

  .user-avatar {
    background: linear-gradient(135deg, #409eff, #2a5298);
    color: #fff;
    font-size: 13px;
    font-weight: 600;
    border: 1.5px solid rgba(255, 255, 255, 0.4);
    flex-shrink: 0;
  }

  .user-meta {
    display: flex;
    flex-direction: column;
    line-height: 1.25;
    max-width: 120px;

    .user-name {
      font-size: 13px;
      font-weight: 600;
      color: #fff;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .user-role {
      font-size: 10px;
      color: rgba(255, 255, 255, 0.6);
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  .arrow {
    color: rgba(255, 255, 255, 0.7);
    font-size: 12px;
  }
}

@keyframes scroll-text {
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(-100%);
  }
}

@media (max-width: 1200px) {
  .header-center {
    display: none;
  }
}

@media (max-width: 768px) {
  .app-header {
    padding: 0 14px;
  }

  .user-trigger .user-meta {
    display: none;
  }
}
</style>
